import { collection, doc, getDoc, getDocs, onSnapshot, orderBy, query } from 'firebase/firestore';
import { db } from '../../helper/firebase.config';

export const getUserData = async (userId) => {
  try {
    if (!userId) {
      throw new Error('User ID is required to fetch credits');
    }
    const userDocRef = doc(db, 'users', userId);
    const userDocSnap = await getDoc(userDocRef);

    if (userDocSnap.exists()) {
      return userDocSnap.data();
    } else {
      console.log('No user found with this ID');
      return null;
    }
  } catch (error) {
    console.error('Error fetching credits:', error);
    throw error;
  }
};

export const getSubscription = async (subscriptionId) => {
  const subscriptionRef = doc(db, 'subscriptions', subscriptionId);
  const subscriptionSnap = await getDoc(subscriptionRef);
  return subscriptionSnap.exists() ? subscriptionSnap.data() : null;
};

export const subscribeToSubscription = (subscriptionId, onUpdate, onError) => {
  if (!subscriptionId) return () => {};

  const subscriptionRef = doc(db, 'subscriptions', subscriptionId);

  const unsubscribe = onSnapshot(
    subscriptionRef,
    (docSnap) => {
      if (docSnap.exists()) {
        onUpdate(docSnap.data());
      } else {
        onUpdate(null);
      }
    },
    (error) => {
      console.error('Error listening to subscription:', error);
      if (onError) onError(error);
    }
  );

  return unsubscribe;
};

export const subscribeToUser = (userId, onUpdate, onError) => {
  if (!userId) return () => {};

  const userRef = doc(db, 'users', userId);

  const unsubscribe = onSnapshot(
    userRef,
    (docSnap) => {
      if (docSnap.exists()) {
        onUpdate(docSnap.data());
      } else {
        onUpdate(null);
      }
    },
    (error) => {
      console.error('Error listening to user data:', error);
      if (onError) onError(error);
    }
  );

  return unsubscribe;
};

export const getCreditTransactions = async (userId) => {
  try {
    if (!userId) {
      throw new Error('User ID is required to fetch credit transactions');
    }

    const creditHistoryRef = collection(db, 'users', userId, 'credit_history');
    const q = query(creditHistoryRef, orderBy('createdAt', 'desc'));

    const querySnapshot = await getDocs(q);

    if (querySnapshot.empty) {
      console.log('No credit transactions found');
      return [];
    }

    // Map to array
    const transactions = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
      createdAt: doc.data().createdAt?.toDate() || null
    }));

    return transactions;
  } catch (error) {
    console.error('Error fetching credit transactions:', error);
    throw error;
  }
};
